import React from 'react';
import './ArtworkDetail.css';

const ArtworkDetail = (props) => {
	const { name, size, url, medium, available } = props.artwork;
	let forsale, sold;

	if (available) {
		forsale = <a href={`mailto:otto178@aol.com?Subject=Enquiry%20about%20artwork:%20${name}`} className="enquire">Enquire about this artwork</a>;
	} else {
		sold = 'sold';
	}
	return(
		<div className="selected-artwork">
			<img src={url} alt={name} />
			<h3>{name}</h3>
			<span>{size} | {medium}</span>
			<span>{sold}</span>
			<button onClick={() => {props.back()}}>Back to Gallery</button>
			{forsale}
		</div>
	);
}

export default ArtworkDetail;


// WEBPACK FOOTER //
// ./src/components/ArtworkDetail.js